import { ConfidenceLevel, ExtractionResultStatus, WebsiteExtractionResult } from "@/types/blueprint.ts";

const websiteExtractionResult: WebsiteExtractionResult = {
  'extraction_result_id': '4fdb11ff-71e1-491d-ba5b-874c8904bd77',
  'created_at': '2025-06-04T12:51:29.011159',
  'updated_at': '2025-06-04T12:51:29.011171',
  'user_id': 'user_001',
  'website_name': 'example.com',
  'insurance_line': 'personal_auto',
  'extraction_result_status': ExtractionResultStatus.PendingReview,
  'categories': [{'model_type': 'CategoryExtractionResult',
    'category_id': '10b74735',
    'reasoning': 'Fields extracted based on entity type heuristics and text matching.',
    'field_answers': [{'field_id': '02b5a314-7216-4e5f-bcde-0be9c1343c40',
      'question': 'Entity Type',
      'answer': 'Personal Name',
      'confidence': ConfidenceLevel.Missing,
      'reasoning': 'Auto-extracted value for Entity Type.'},
     {'field_id': '63c25b3a-4b06-478a-b5ec-efbc88173da9',
      'question': 'Prefix',
      'answer': 'Mr.',
      'confidence': ConfidenceLevel.Medium,
      'reasoning': 'Auto-extracted value for Prefix.'},
     {'field_id': 'ca00c47b-0e5d-4f58-8448-0d55c2e035db',
      'question': 'First Name',
      'answer': 'John',
      'confidence': ConfidenceLevel.Low,
      'reasoning': 'Auto-extracted value for First Name.'},
     {'field_id': 'cf104bc0-c82f-4f1b-8d2a-55317eda72e6',
      'question': 'Suffix',
      'answer': 'Jr.',
      'confidence': ConfidenceLevel.Missing,
      'reasoning': 'Auto-extracted value for Suffix.'},
     {'field_id': '1e123da0-46e8-4e3d-a857-501f6552fc1d',
      'question': 'SSN',
      'answer': '123-45-6789',
      'confidence': ConfidenceLevel.Medium,
      'reasoning': 'Auto-extracted value for SSN.'},
     {'field_id': '726ea530-eda0-4463-b016-b1b50fe1dee1',
      'question': 'Gender',
      'answer': 'Male',
      'confidence': ConfidenceLevel.Missing,
      'reasoning': 'Auto-extracted value for Gender.'},
     {'field_id': '25c4d32c-f4b6-4ce7-b16b-3e0d8d24d791',
      'question': 'Marital Status',
      'answer': 'Single',
      'confidence': ConfidenceLevel.Missing,
      'reasoning': 'Auto-extracted value for Marital Status.'},
     {'field_id': '4e5ccf66-da4b-4efb-9bef-8db9eb5f3c4a',
      'question': 'Date of Birth',
      'answer': '1990-01-01',
      'confidence': ConfidenceLevel.Low,
      'reasoning': 'Auto-extracted value for Date of Birth.'},
     {'field_id': '6c00e2e6-bfdd-402c-91c8-068600036978',
      'question': 'DL Number',
      'answer': 'D1234567',
      'confidence': ConfidenceLevel.Missing,
      'reasoning': 'Auto-extracted value for DL Number.'},
     {'field_id': '7316999e-231f-4f64-87a8-ba3051845285',
      'question': 'DL Country',
      'answer': 'USA',
      'confidence': ConfidenceLevel.Medium,
      'reasoning': 'Auto-extracted value for DL Country.'},
     {'field_id': 'a207cbb4-d910-4151-a8f1-689199cf60fd',
      'question': 'DL State',
      'answer': 'CA',
      'confidence': ConfidenceLevel.Medium,
      'reasoning': 'Auto-extracted value for DL State.'},
     {'field_id': 'e5dd4707-a7f1-4198-b2e9-0aaf28bddecb',
      'question': 'Date Licensed',
      'answer': '2010-05-15',
      'confidence': ConfidenceLevel.High,
      'reasoning': 'Auto-extracted value for Date Licensed.'},
     {'field_id': 'c7f25910-1975-4b05-bd12-0d2493bdf52d',
      'question': 'Home Phone',
      'answer': '123-456-7890',
      'confidence': ConfidenceLevel.Medium,
      'reasoning': 'Auto-extracted value for Home Phone.'},
     {'field_id': '2e3c96ee-9eab-4d41-88e6-20cc752075f8',
      'question': 'Work Phone',
      'answer': '234-567-8901',
      'confidence': ConfidenceLevel.High,
      'reasoning': 'Auto-extracted value for Work Phone.'},
     {'field_id': 'fb05f521-189c-4719-9a22-379336db93f2',
      'question': 'Ext',
      'answer': '123',
      'confidence': ConfidenceLevel.Medium,
      'reasoning': 'Auto-extracted value for Ext.'},
     {'field_id': '394e7278-3e78-4c26-8642-5b7cf0bc5cef',
      'question': 'Mobile Phone',
      'answer': '345-678-9012',
      'confidence': ConfidenceLevel.Low,
      'reasoning': 'Auto-extracted value for Mobile Phone.'},
     {'field_id': 'a75c834c-1e79-4f81-8de3-edc92b28d779',
      'question': 'Email Address',
      'answer': 'john.doe@example.com',
      'confidence': ConfidenceLevel.Low,
      'reasoning': 'Auto-extracted value for Email Address.'},
     {'field_id': '6f881100-70ac-45a7-8cd2-547792b7639c',
      'question': 'Occupation',
      'answer': 'Engineer',
      'confidence': ConfidenceLevel.Medium,
      'reasoning': 'Auto-extracted value for Occupation.'},
     {'field_id': '60f09e82-f80f-4af9-b03a-8a5118ec2d42',
      'question': 'Cincinnati Associate',
      'answer': 'No',
      'confidence': ConfidenceLevel.Missing,
      'reasoning': 'Auto-extracted value for Cincinnati Associate.'},
     {'field_id': 'c9ec1fbf-8942-410b-a638-096165fd78a2',
      'question': 'AVS Client Code',
      'answer': 'AVS12345',
      'confidence': ConfidenceLevel.Low,
      'reasoning': 'Auto-extracted value for AVS Client Code.'},
     {'field_id': 'd4d82b81-c312-4375-b05b-299618f9b09d',
      'question': 'Name 1',
      'answer': 'Acme Corp',
      'confidence': ConfidenceLevel.High,
      'reasoning': 'Auto-extracted value for Name 1.'},
     {'field_id': '665407e7-0e9f-417a-9760-b904383ad943',
      'question': 'Name 2',
      'answer': 'Subsidiary LLC',
      'confidence': ConfidenceLevel.Missing,
      'reasoning': 'Auto-extracted value for Name 2.'},
     {'field_id': 'e63d64a2-9fed-42ac-b943-5b6919e4f246',
      'question': 'FEIN',
      'answer': '12-3456789',
      'confidence': ConfidenceLevel.Missing,
      'reasoning': 'Auto-extracted value for FEIN.'}]}]};

export {
  websiteExtractionResult
}